export enum ShiftType {
  ALL = 'ALL',
  EARLY = 'EARLY',
  LATE = 'LATE',
  NIGHT = 'NIGHT',
}
